'use client'

import { NextIntlClientProvider } from 'next-intl'
import { ReactNode } from 'react'
import { Cultures } from '@/types/enums'

// Import translations
import enUSMessages from '@/translations/en-US.json'
import nlNLMessages from '@/translations/nl-NL.json'

// Create messages object mapping cultures to their translations
const messages = {
  [Cultures['en-US']]: enUSMessages,
  [Cultures['nl-NL']]: nlNLMessages,
}

interface I18nProviderProps {
  children: ReactNode
  culture: Cultures
  umbracoMessages: Record<string, string>
}

/**
 * Provider that sets up internationalization for the application
 */
export function I18nProvider({ children, culture, umbracoMessages }: I18nProviderProps) {
  const combinedMessages = {
    ...messages[culture],
    ...umbracoMessages,
  }

  return (
    <NextIntlClientProvider
      locale={culture}
      messages={combinedMessages}
      timeZone='Europe/Amsterdam'
    >
      {children}
    </NextIntlClientProvider>
  )
}
